// extracted by mini-css-extract-plugin
export default {"TaskListMenuTriggerButton":"TaskListMenu-module__TaskListMenuTriggerButton--Qskh6"};